import moment from 'moment';
import { UIFileFormat } from '../config/dates';
import mime from 'mime-types';

export const newFile = (data, fileName, contentType) => {
	const blob = new Blob([data], {type: contentType})
	const url = window.URL.createObjectURL(blob);
	const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
	a.href = url;
	a.download = fileName;
	a.click();
	window.URL.revokeObjectURL(url);
}


export const handleDownload = (fileName, response) => {
	const contentType = response.headers["content-type"];
	const extension = mime.extension(contentType);
	newFile(response.data, `${fileName}.${extension}`, contentType)
}